import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';

import { CloseIcon, DragDropV2Icon, IconButton } from '@utilities';

import styles from './_index.module.scss';

const Top2BoxItem = ({ index, item, onRemove }) => (
  <Draggable draggableId={item.id} index={index}>
    {(provided, snapshot) => (
      <div
        aria-label={item.label}
        className={styles['top-2-box-item']}
        data-dragging={snapshot.isDragging || undefined}
        ref={provided.innerRef}
        {...provided.dragHandleProps}
        {...provided.draggableProps}
      >
        <div className={styles['top-2-box-item-label']}>
          <DragDropV2Icon />
          <span>{item.label}</span>
        </div>
        {onRemove && (
          <IconButton aria-label={`Remove ${item.label}`} onClick={() => onRemove(item)}>
            <CloseIcon />
          </IconButton>
        )}
      </div>
    )}
  </Draggable>
);

Top2BoxItem.propTypes = {
  index: PropTypes.number.isRequired,
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  onRemove: PropTypes.func,
};

export default Top2BoxItem;
